"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RealTime = exports.WidgetCategories = exports.Orders = exports.WidgetTypes = exports.MapViewElementTooltipPositions = exports.MetricAggregations = void 0;
var MetricAggregations;
(function (MetricAggregations) {
    MetricAggregations["AVERAGE"] = "AVERAGE";
    MetricAggregations["SUM"] = "SUM";
    MetricAggregations["MIN"] = "MIN";
    MetricAggregations["MAX"] = "MAX";
    MetricAggregations["COUNT"] = "COUNT";
    MetricAggregations["PERCENTAGE"] = "PERCENTAGE";
    MetricAggregations["WEIGHTED_PERCENTAGE"] = "WEIGHTED_PERCENTAGE";
    MetricAggregations["FIRST"] = "FIRST";
    MetricAggregations["LAST"] = "LAST";
    MetricAggregations["MEDIAN"] = "MEDIAN";
    MetricAggregations["PERCENTILE_95"] = "PERCENTILE_95";
    MetricAggregations["PERCENTILE_75"] = "PERCENTILE_75";
    MetricAggregations["PERCENTILE_25"] = "PERCENTILE_25";
    MetricAggregations["EVOLUTION"] = "EVOLUTION";
})(MetricAggregations = exports.MetricAggregations || (exports.MetricAggregations = {}));
var MapViewElementTooltipPositions;
(function (MapViewElementTooltipPositions) {
    MapViewElementTooltipPositions["LEFT"] = "LEFT";
    MapViewElementTooltipPositions["RIGHT"] = "RIGHT";
    MapViewElementTooltipPositions["TOP"] = "TOP";
    MapViewElementTooltipPositions["BOTTOM"] = "BOTTOM";
    MapViewElementTooltipPositions["CENTER"] = "CENTER";
})(MapViewElementTooltipPositions = exports.MapViewElementTooltipPositions || (exports.MapViewElementTooltipPositions = {}));
var WidgetTypes;
(function (WidgetTypes) {
    WidgetTypes["AREA_CHART"] = "AREA_CHART";
    WidgetTypes["BAR_CHART"] = "BAR";
    WidgetTypes["COLUMN_CHART"] = "COLUMN";
    WidgetTypes["GRID_CHART"] = "GRID_CHART";
    WidgetTypes["MAP_VIEW"] = "MAP_VIEW";
    WidgetTypes["HEATMAP"] = "HEATMAP";
    WidgetTypes["LINE_CHART"] = "LINE_CHART";
    WidgetTypes["PIE_CHART"] = "PIE_CHART";
    WidgetTypes["TABLE"] = "TABLE";
    WidgetTypes["KPIS"] = "KPIS";
    WidgetTypes["CIRCLE_CHART"] = "CIRCLE_CHART";
    WidgetTypes["PROGRESS_BAR_CHART"] = "PROGRESS_BAR_CHART";
    WidgetTypes["WEB_CHART"] = "WEB_CHART";
})(WidgetTypes = exports.WidgetTypes || (exports.WidgetTypes = {}));
var Orders;
(function (Orders) {
    Orders["ASC"] = "ASC";
    Orders["DESC"] = "DESC";
})(Orders = exports.Orders || (exports.Orders = {}));
var WidgetCategories;
(function (WidgetCategories) {
    WidgetCategories["GLOBAL"] = "GLOBAL";
    WidgetCategories["SPECIFIC"] = "SPECIFIC";
})(WidgetCategories = exports.WidgetCategories || (exports.WidgetCategories = {}));
var RealTime;
(function (RealTime) {
    RealTime["LIVE"] = "LIVE";
    RealTime["FAST_POLL"] = "FAST_POLL";
    RealTime["SLOW_POLL"] = "SLOW_POLL";
})(RealTime = exports.RealTime || (exports.RealTime = {}));
